// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"b9de845c","487":"47717fb6"}[chunkId] + ".chunk.css";
};